var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"4","viewBox":"0 0 8 4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.666672 0.666666L4 4L7.33334 0.666666H0.666672Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }